import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ModalComponent from './ModalCorreo';
import $ from 'jquery';
import { abrirModal, regresarTipo } from './reducer/todo-reducer';



class Cotizacion extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mostrar: false
        }

    }


    componentDidMount() {
        $(window).scrollTop(0);
        console.log(this.props.cotizacion);
    }

    componentWillReceiveProps(nexProps) {

        if (nexProps.cierraModal === true) {
            this.setState({ mostrar: nexProps.cierraModal });
        }



    }

    render() {
        return (

            <div style={{ maxWidth: "570px", margin: "auto auto" }}>



                <div className="backCotizacionEducacionDesktop hidden-xs">

                    <div className="divTituloEducacion">
                        <label className="iconoCotDesktop" />
                        <label className="requiredIn labelTituloDesktop" >Asegura la colegiatura de tus hijos</label>
                        <label className="iconoPrintDesk" onClick={this.impresion.bind(this)} />
                        <label className="iconoMailDesk" onClick={this.enviaCorreo.bind(this)} />
                    </div>

                    <div className="desc1">
                        <label className="requiredIn">Con Profesional de GNP<br />ahorrando<br /> mensualmente:</label>
                    </div>

                    <div className="desc2">
                        <label className="requiredIn">Lograrás un ahorro<br />garantizado de:</label>
                    </div>


                    <div className="MontoMensual">
                        <label className="requiredIn"
                            style={{ fontWeight: "bold", fontSize: "20px" }}
                        >
                            ${this.formato(this.props.cotizacion.cotizacion)}*</label>
                    </div>

                    <div className="AhorroGarantizado">
                        <label className="requiredIn"
                            style={{ fontWeight: "bold", fontSize: "20px" }}
                        >
                            ${this.formato(this.props.cotizacion.ahorroGarantizado)}*</label>
                    </div>

                    <div className="Adicionalmente">
                        <p className="pCotizacion">Adicionalmente, si desafortunadamente llegaras a faltar antes <br />
                        de ese plazo, se les entregará a tus beneficiarios ${this.formato(this.props.cotizacion.ahorroGarantizado)} <br />
                        adicionales al Ahorro Garantizado que se le dará a tu hijo a los {this.formato(this.props.cotizacion.tipo)} años para su educación.</p>
                    </div>


                </div>




                <div className="AdemasElige hidden-xs">
                    <div className="contentAdemas">
                        <label className="titleAdemas">Además, elige:</label>

                        <div className="otro">
                            <ul>
                                <li>La forma de entrega del ahorro: pago único o fideicomiso.</li>
                            </ul>
                        </div>

                        <div className="otro">
                            <ul>
                                <li>Protección adicional en caso de invalidez.</li>
                            </ul>
                        </div>

                        <div className="otro">
                            <ul>
                                <li>En caso de ser mujer, protección para padecimientos frecuentes o exclusivos de tu género.</li>
                            </ul>
                        </div>

                        <div className="otro">
                            <ul>
                                <li>El tipo de moneda, puedes contratarlo en moneda nacional o dólares.</li>
                            </ul>
                        </div>

                        <div className="otro">
                            <ul>
                                <li>Diversas formas de pago.</li>
                            </ul>
                        </div>

                    </div>

                </div>
                <div className="col-xs-12 text-right hidden-xs" style={{ maxWidth: "570px" }}>
                    <br />
                    <button className="btn btn-return" onClick={this.regresarTipo.bind(this)}>Cotizar de nuevo</button>&nbsp;&nbsp;&nbsp;&nbsp;
                    <br />
                </div>



                <div className="hidden-xs">
                    <div className="conoceText">
                        <br />
                        <br />
                        <p>
                            ¡Conoce los beneficios adicionales que Profesional tiene para ti y tu familia!
                        </p>
                    </div>

                    <div className="contactaLink">
                        <p><a href="https://www.gnp.com.mx/post-venta/solicita-un-agente">Contacta a tu agente de seguros aquí</a></p>
                    </div>

                    <div className="etiquetaAzul" style={{ marginLeft: "10px" }}>
                        <label>*La prima y suma asegurada se actualizan con la inflación</label>

                    </div>
                </div>




                <div className="formulario-cotiza hidden-md hidden-sm hidden-lg">
                    <div className="titulo">
                        <label className="iconoCotResponsive" />
                        <label>Asegura la colegiatura de tu hijos</label>
                        <label className="iconoMailResp" onClick={this.enviaCorreo.bind(this)} />
                    </div>
                    <div className="contenidoFormulario">

                        <div className="col-xs-12">
                            <div className="col-xs-6 text-center">
                                <label className="requiredIn">Con Profesional de GNP ahorrando mensualmente:</label>
                                <br />
                                <label className="requiredInResult">${this.formato(this.props.cotizacion.cotizacion)}*</label>
                            </div>

                            <div className="col-xs-6 text-center">
                                <label className="requiredIn">Lograrás un ahorro<br />garantizado de:</label>
                                <br />
                                <label className="requiredInResult">${this.formato(this.props.cotizacion.ahorroGarantizado)}*</label>
                            </div>
                        </div>

                    </div>

                    <div className="col-xs-12 adicionalmenteMovil">
                        <p className="texoCotRes">Adicionalmente, si desafortunadamente llegaras a faltar antes <br />
                        de ese plazo, se les entregará a tus beneficiarios ${this.formato(this.props.cotizacion.ahorroGarantizado)} <br />
                        adicionales al Ahorro Garantizado que se le dará a tu hijo a los {this.formato(this.props.cotizacion.tipo)} años para su educación.</p>
                    </div>

                    <div className="contenidoFormulario">
                        <div className="contentAdemas">
                            <label className="titleAdemasMovil">Además, elige:</label>
                        </div>

                        <div className="otroMovil">
                            <ul>
                                <li>La forma de entrega del ahorro: pago único o fideicomiso.</li>
                            </ul>
                        </div>

                        <div className="otroMovil">
                            <ul>
                                <li>Protección adicional en caso de invalidez.</li>
                            </ul>
                        </div>

                        <div className="otroMovil">
                            <ul>
                                <li>En caso de ser mujer, protección para padecimientos frecuentes o exclusivos de tu género.</li>
                            </ul>
                        </div>

                        <div className="otroMovil">
                            <ul>
                                <li>El tipo de moneda, puedes contratarlo en moneda nacional o dólares.</li>
                            </ul>
                        </div>

                        <div className="otroMovil">
                            <ul>
                                <li>Diversas formas de pago.</li>
                            </ul>
                        </div>

                        <div className="conoceTextMovil">
                            <p>
                                ¡Conoce los beneficios adicionales que Profesional tiene para ti y tu familia!
                            </p>
                        </div>

                        <div className="contactaLink">
                            <p><a href="https://www.gnp.com.mx/post-venta/solicita-un-agente"  >Contacta a tu agente de seguros aquí</a></p>
                        </div>

                        <div className="etiquetaAzul" style={{ marginLeft: "10px" }}>
                            <label>*La prima y suma asegurada se actualizan con la inflación</label>

                        </div>
                    </div>
                </div>


                <ModalComponent cotizacion={this.props.cotizacion} mostrar={this.state.mostrar} />
            </div>





        )
    }

    regresarTipo(event) {
        window.location.reload();
    }

    formato(cantidad) {
        return Math.floor(cantidad).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    enviaCorreo(event) {
        this.props.actions.abrirModal();
    }

    impresion(event) {
        window.print();
    }

}
const mapStateToProps = (state) => {
    return {
        correoEnviado: state.educacionReducer.get("correoEnviado"),
        cierraModal: state.educacionReducer.get("cierraModal"),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ abrirModal: abrirModal, regresarTipo: regresarTipo }, dispatch)
    }
}





export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Cotizacion);



// WEBPACK FOOTER //
// ./src/Cotizacion.js